
import Vue from "vue";
import AppProjectInfoProperties from "./ProjectInfoProperties.vue";
import { Project } from "@/models/base";

export default Vue.extend({
	props: {
		project: {
			type: Object as () => Project,
			required: true
		},
		lg: {
			type: [Number, String]
		},
		md: {
			type: [Number, String]
		}
	},
	components: {
		AppProjectInfoProperties,
	},
	i18nEx: {
		componentPrefix: "components.project"
	}
});
